export const DEFAULT_HEARTBEAT_MESSAGE = '--heartbeat--'

/**
 * Коды события close у сокета
 * https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
 * */
export const SocketCloseCode = {
  NormalClosure: 1000,
  GoingAway: 1001,
  ProtocolError: 1002,
  UnsupportedData: 1003,
  Reserved: 1004,
  NoStatusReceived: 1005,
  AbnormalClosure: 1006,
  InvalidFramePayloadData: 1007,
  PolicyViolation: 1008,
  MessageTooBig: 1009,
  MandatoryExt: 1010,
  InternalError: 1011,
  ServiceRestart: 1012,
  TryAgainLater: 1013,
  BadGateway: 1014,
  TLSHandshake: 1016,
} as const
